export const STRIPE_API_KEY = window.config.REACT_APP_STRIPE_API_KEY;
export const BEANIE_API_KEY = window.config.REACT_APP_BEANIE_API_KEY;
export const BEANIE_CONFIG_ID = window.config.REACT_APP_BEANIE_CONFIG_ID;

export const PRODUCT_ADVANCED_MONTHLY = window.config.REACT_APP_PRODUCT_ADVANCED_MONTHLY;
export const PRODUCT_ADVANCED_YEARLY = window.config.REACT_APP_PRODUCT_ADVANCED_YEARLY;
export const PRODUCT_ADVANCED_PRICES = {
  monthly: 39,
  yearly: 29,
};

export const PRODUCT_PROFESSIONAL_MONTHLY = window.config.REACT_APP_PRODUCT_PROFESSIONAL_MONTHLY;
export const PRODUCT_PROFESSIONAL_YEARLY = window.config.REACT_APP_PRODUCT_PROFESSIONAL_YEARLY;
export const PRODUCT_PROFESSIONAL_PRICES = {
  monthly: 799,
  yearly: 599,
};

export const BILLING_CYCLE_MONTHLY = 'monthly';
export const BILLING_CYCLE_YEARLY = 'yearly';
